import { TextInput, useListContext, Form, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import SearchIcon from '@/assets/icons/search-icon.svg?react';
import { InputAdornment, CircularProgress } from '@mui/material';
import { useState } from 'react';

const StyledSearchForm = styled(Form)(({ theme }) => ({
    '&.search-form': {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
        '& .MuiFormControl-root': {
            margin: '0px',
            maxWidth: '240px',
            '& .MuiFormLabel-root': {
                left: '-5px',
            },
            '& .MuiInputLabel-shrink': {
                backgroundColor: Palette.gray.gray75,
                left: '0px',
            },
        },
        '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
        },
        '& .MuiFormHelperText-root': {
            display: 'none',
        },
    },
}));

export const SearchFilterInput = ({ searchFields }) => {
    const { setFilters, filterValues, isFetching } = useListContext();
    const [isLoading, setIsLoading] = useState(false);
    const translate = useTranslate();

    const handleSearchChange = event => {
        setIsLoading(true);
        const searchValue = event.target.value;
        setFilters({
            ...filterValues,
            search: {
                value: searchValue,
                fields: searchFields ?? filterValues?.search?.fields ?? {},
            },
        });
    };

    return (
        <StyledSearchForm className='search-form'>
            <TextInput
                source='search'
                label={translate('common.search')}
                onChange={handleSearchChange}
                defaultValue={filterValues?.search?.value || ''}
                name='search'
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                            {isFetching && isLoading ? <CircularProgress size={20} color='primary' /> : <SearchIcon />}
                        </InputAdornment>
                    ),
                }}
            />
        </StyledSearchForm>
    );
};

SearchFilterInput.propTypes = {
    className: PropTypes.string,
    searchFields: PropTypes.object,
};
